import React from "react";

import { Image as ImageComponent, ImageProps } from "@touchtech/baselayer-ui";
import { Spinner } from "@touchtech/web-baselayer-ui";

import { MediaVariants, PLACEHOLDER_IMAGE_SRC } from "@is/constants";
import { useMedia } from "@is/hooks/media-manager";
import { CacheEntryPriority } from "@is/services/MemoryCache";
import { MediaVariant } from "@is/types";
import { getImageUri } from "@is/utils";
import { getEnvValue } from "@is/utils/env";

type Props = ImageProps & {
  mediavariant: MediaVariant;
  showloadingspinner?: boolean;
  priority?: CacheEntryPriority;
  placeholderMediaVariant?: MediaVariant;
};

function Image({
  loading = "lazy",
  showloadingspinner,
  priority,
  placeholderMediaVariant = MediaVariants.THUMBNAIL,
  mediavariant,
  ...props
}: Props) {
  const { src: placeholderSrc } = useMedia(
    getImageUri(
      getEnvValue("VITE_IMAGE_SERVICE_URL"),
      props.src,
      placeholderMediaVariant
    ),
    {
      placeholderSrc: PLACEHOLDER_IMAGE_SRC,
      cachePriority: CacheEntryPriority.NEVER_REMOVE,
    }
  );

  const { src, isLoading } = useMedia(
    getImageUri(getEnvValue("VITE_IMAGE_SERVICE_URL"), props.src, mediavariant),
    {
      placeholderSrc: PLACEHOLDER_IMAGE_SRC,
      cachePriority: priority,
    }
  );

  return (
    <ImageComponent
      {...props}
      src={isLoading ? placeholderSrc : src}
      loading={loading}
    >
      {showloadingspinner && isLoading ? <Spinner /> : props.children}
    </ImageComponent>
  );
}

export default Image;
